import { render, staticRenderFns } from "./ReferralsPoolProvidersModal.vue?vue&type=template&id=c67b3bc0&scoped=true"
import script from "./ReferralsPoolProvidersModal.vue?vue&type=script&lang=js"
export * from "./ReferralsPoolProvidersModal.vue?vue&type=script&lang=js"
import style0 from "./ReferralsPoolProvidersModal.vue?vue&type=style&index=0&id=c67b3bc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67b3bc0",
  null
  
)

export default component.exports